<template>
  <div class="document-downloads">
    <ul class="grid grid--s16" v-for="(item, index) in downloadLinks">
      <li :key="index" class="grid__item">
        <a :href="item.download.link" target="_blank" class="document-downloads__item">
          <div class="grid grid--g28 grid--s0 grid--auto grid--nowrap grid--middle">
            <div class="grid__item">
              <div class="document-downloads__image-wrapper">
								<img class="document-downloads__image" v-if="item.download.type=='image'" :src="item.download.link" />
								<img class="document-downloads__image" v-else :src="$root.requireIcon(item.download.name, item.download.type)" />
              </div>
            </div>
            <div class="grid__item grid__item--space">
              <span class="document-downloads__text">{{ item.download.metadata || item.download.name }}</span>
            </div>
            <div class="grid__item">
              <span class="document-downloads__link link--action link--colored link--arrow">Download</span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
      downloadLinks: Array,
      text: String
  }
};
</script>

<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".document-downloads";
	#{$c}
	{
		&__item
		{
			display: block;
			background-color: white;
			padding: rem(16) rem(32) rem(16) rem(20);
			margin-bottom: 16px;
			cursor: pointer;
		}

		&__image-wrapper
		{
			display: flex;
			align-items: center;
			justify-content: center;
			width: rem(60);
			height: rem(60);
		}

		&__image
		{
			max-width: 100%;
			max-height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/DocumentDownloads.vue